import React from 'react';

const assignmentContextDefaultValues = {
  assignmentParams: {
    assignmentInstanceId: null,
    assignmentId: null,
    mloId: null,
    classId: null,
    groupId: null,
    organisationName: null,
    trimesterOrder: null,
    contextId: null,
    academicYearId: null,
    returnUrl: null,
    trimesterId: null,
    instructionalPlanId: null,
    language: null,
    studentId: null,
    isGradableItemsLockedByDefault: null,
    finishExperienceContext: null,
  },
  assignmentData: {
    assignmentId: null,
    assignmentType: null,
  },
  methods: { refetchStudentAssignment: () => {} },
};

const AssignmentContext = React.createContext(assignmentContextDefaultValues);

export default AssignmentContext;
